import { render, staticRenderFns } from "./OrkReassurance.html?vue&type=template&id=4a8478aa&scoped=true&"
import script from "./OrkReassurance.vue?vue&type=script&lang=js&"
export * from "./OrkReassurance.vue?vue&type=script&lang=js&"
import style0 from "./OrkReassurance.scss?vue&type=style&index=0&id=4a8478aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8478aa",
  null
  
)

export default component.exports